import { UnknownProviderError } from '../../errors/unknown-provider-error';

export class UnknownLinkedInError extends UnknownProviderError {
	constructor(cause: any) {
		super(cause);
		this.name = 'UnknownLinkedInError';
	}
}
